/* eslint-disable max-len */
import { AccordionSummary } from '@mui/material';
import React, { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { LanguageContext } from '../../libs/Context';
import PropTypes from 'prop-types';

const AccordainSummaryHtml = (props) =>
{
	const { setAction, action, type, uploading, uploadedCount, uploadFile, handleClose } = props;
	const { language } = useContext(LanguageContext);

	const renderUploadStatus = () =>
	{
		let itemCount;

		if (uploadFile?.length > 1)
		{
			itemCount = `${uploadFile.length} ${language.item}`;
		}
		else
		{
			itemCount = `1 ${language.item}`;
		}
		if (type === 'fileupload')
		{
			if (!uploading)
			{
				return `${uploadedCount} Items Uploaded`;
			}
			else
			{
				return `${itemCount} ${language?.uploading}`;
			}
		}
		else
		{
			return `${itemCount} ${language?.uploading}`;
		}
	};

	return (
		<AccordionSummary
			sx={{ backgroundColor: '#DCEAF1', position: 'relative' }}
			expandIcon={
				<ExpandLessIcon
					onClick={() =>
						setAction({ ...action, expanded: !action?.expanded })
					}
					sx={{
						position : 'absolute',
						right    : action.expanded ? -70 : 35,
						top      : -17,
						color    : 'black',
						fontSize : 34
					}}
				/>
			}
			aria-controls='panel1a-content'
			id='panel1a-header'
		>
			<div className='flexRow alignCntr'>
				<div className='flexMinWidthRow'>
					<span className='fontWeightMD'>
						{renderUploadStatus()}
					</span>
				</div>
				<button onKeyUp={handleClose} className='flexAutoRow pointer' onClick={handleClose}>
					<CloseIcon />
				</button >
			</div>
		</AccordionSummary>
	);
};

AccordainSummaryHtml.propTypes = {
	setAction     : PropTypes.func,
	action        : PropTypes.object,
	type          : PropTypes.string,
	uploading     : PropTypes.bool,
	uploadedCount : PropTypes.number,
	uploadFile    : PropTypes.array,
	handleClose   : PropTypes.func
};

export default AccordainSummaryHtml;
